import { isPlatformBrowser } from '@angular/common';
import {  ChangeDetectorRef, Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Subject, takeUntil } from 'rxjs';
import { CombiOptionListItem } from '@app/models/hotels/CombiOptionListItem';
interface Item {
    code: string;
    name: string;
}
@Component({
    selector: 'clever-roomid',
    templateUrl: './roomid.component.html',
    styleUrls: ['./roomid.component.scss'],
    standalone: false
})
export class RoomidComponent implements OnInit {
    @Input() mode: string;
    @Input() roomIdList: Item[];
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    alredyChecked: boolean = false;
    slicenbr: number = 5;

    selectedList: string[] = [];
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initRoomCode();
            this.initFilterSub();
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    sortArray(array): any[] {
        if (array?.length > 0) {
            array?.sort((a, b) => {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();

                return a < b ? -1 : a > b ? 1 : 0;
            });
        }
        return array;
    }

    showMore(all) {
        this.slicenbr = all;
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.selectedList = [];
            if (filter.roomIdList?.length > 0) {
                for (let i = 0; i < filter.roomIdList.length; i++) {
                    this.selectedList.push(filter.roomIdList[i].code);
                }
            }
            this.cdr.markForCheck();
        });
    }

    initRoomCode(): void {
        this.hotelService.subCombiOptionListItem$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((codes: CombiOptionListItem) => {
            if (!this.alredyChecked && codes?.valueList?.length > 0) {
                for (let j = 0; j < this.roomIdList.length; j++) {
                    for (let i = 0; i < codes.valueList.length; i++) {
                        if (this.roomIdList[j].code === codes.valueList[i]?.roomId?.code) {
                            if (codes.valueList[i]?.locationCode?.name?.length > 0) {
                                this.roomIdList[j].name = this.roomIdList[j].name + ' ' + codes.valueList[i]?.locationCode.name
                            }
                            if (codes.valueList[i]?.amenityCode?.name?.length > 0) {
                                this.roomIdList[j].name = this.roomIdList[j].name + ' ' + codes.valueList[i]?.amenityCode.name
                            }
                            i = codes.valueList.length;
                        }
                    }
                }
                this.alredyChecked = true;
                this.cdr.markForCheck();
            }
        });
    }

    selected(op): void {
        let push = true;
        if (this.selectedList.indexOf(op.code) >= 0) {
            push = false;
        }
        this.hotelService.roomIdList(op, push);
        this.cdr.markForCheck();
    }
}
